import type { OnDestroy, OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastAlertService, ToastAlertType } from '@freelancer/ui/toast-alert';
import type { Subscription } from 'rxjs';

@Component({
  selector: 'app-invitation-redirect-alert',
  template: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvitationRedirectAlertComponent implements OnInit, OnDestroy {
  ToastAlertType = ToastAlertType;

  private alertSubscription?: Subscription;

  constructor(
    private route: ActivatedRoute,
    private toastAlertService: ToastAlertService,
  ) {}

  ngOnInit(): void {
    this.alertSubscription = this.route.queryParamMap.subscribe(params => {
      if (params.get('report_success') === 'true') {
        this.toastAlertService.open({
          message: $localize`Report successful!`,
          timeout: 5000,
          type: ToastAlertType.SUCCESS,
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.alertSubscription?.unsubscribe();
  }
}
